import { render, staticRenderFns } from "./BnlpSection.vue?vue&type=template&id=878ca2fa&scoped=true&"
import script from "./BnlpSection.vue?vue&type=script&lang=js&"
export * from "./BnlpSection.vue?vue&type=script&lang=js&"
import style0 from "./BnlpSection.vue?vue&type=style&index=0&id=878ca2fa&prod&lang=postcss&"
import style1 from "./BnlpSection.vue?vue&type=style&index=1&id=878ca2fa&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "878ca2fa",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppImg: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/common/AppImg.vue').default,CmsLink: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/cms/CmsLink.vue').default})
